import { render, staticRenderFns } from "./CenterDailyCalendar.vue?vue&type=template&id=352b845a&scoped=true"
import script from "./CenterDailyCalendar.vue?vue&type=script&lang=js"
export * from "./CenterDailyCalendar.vue?vue&type=script&lang=js"
import style0 from "./CenterDailyCalendar.vue?vue&type=style&index=0&id=352b845a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352b845a",
  null
  
)

export default component.exports